/**
 * 在应用最早阶段包装 navigator.hid.requestDevice，拦截 HFD / 贝盈 SDK 等内部调用。
 * 固件升级进 Boot 后允许回退到已授权 getDevices，避免概率性 noDevice。
 */
import {
  canInvokeHidRequestDevice,
  getAuthorizedHidDevicesForUpgradeRequest,
} from "./webHidAuth";
import { isKeyboardFirmwareUpgradeInProgress } from "@eweadn-qiankun/shared-utils";

const GUARD_INSTALLED = Symbol.for("eweadn.hidRequestDeviceGuard");

export function installHidRequestDeviceGuard(): void {
  if (typeof navigator === "undefined" || !("hid" in navigator)) return;
  const hid = (navigator as any).hid;
  if (hid[GUARD_INSTALLED]) return;

  const nativeRequestDevice =
    typeof hid.requestDevice === "function"
      ? hid.requestDevice.bind(hid)
      : null;
  if (!nativeRequestDevice) return;

  hid.requestDevice = async function guardedRequestDevice(options: unknown) {
    if (!canInvokeHidRequestDevice()) {
      if (isKeyboardFirmwareUpgradeInProgress()) {
        console.log(
          "[installHidRequestDeviceGuard] 固件升级中：requestDevice 回退 getDevices"
        );
        return getAuthorizedHidDevicesForUpgradeRequest(
          options as HIDDeviceRequestOptions
        );
      }
      console.log(
        "[installHidRequestDeviceGuard] 已拦截 navigator.hid.requestDevice"
      );
      return [];
    }
    return nativeRequestDevice(options);
  };
  hid[GUARD_INSTALLED] = true;
}
